import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";

import { focusTrap } from "../../helpers/focusTrap";

// styles
import FlyoutStyled from "./Flyout.styled";
import ThemeProviderStyled from "../../theme/ThemeProvider.styled";

const Flyout = ({
  children,
  openFlyout,
  closeFlyout,
  closeBtn,
  closeLabel,
  padding,
}) => {
  useEffect(() => {
    const closeOnEscapeKey = ({ key }) =>
      key === "Escape" && openFlyout ? closeFlyout() : null;

    document.body.addEventListener("keydown", closeOnEscapeKey);
    return () => {
      document.body.removeEventListener("keydown", closeOnEscapeKey);
    };
  }, [openFlyout, closeFlyout]);

  return (
    <ThemeProvider theme={ThemeProviderStyled}>
      <FlyoutStyled open={openFlyout} padding={padding}>
        <div className="flyoutInner" onKeyDown={(e) => focusTrap(e)}>
          <button
            type="button"
            className="closeBn"
            ref={closeBtn}
            onClick={closeFlyout}
          >
            <svg
              aria-hidden="true"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0821 2.33212C11.4727 1.94159 11.4727 1.30843 11.0821 0.917902C10.6916 0.527378 10.0584 0.527378 9.66792 0.917902L11.0821 2.33212ZM0.917921 9.6679C0.527396 10.0584 0.527396 10.6916 0.917921 11.0821C1.30844 11.4726 1.94161 11.4726 2.33213 11.0821L0.917921 9.6679ZM9.66789 11.0821C10.0584 11.4726 10.6916 11.4726 11.0821 11.0821C11.4726 10.6916 11.4726 10.0584 11.0821 9.66789L9.66789 11.0821ZM2.33211 0.917893C1.94158 0.527369 1.30842 0.527369 0.917893 0.917893C0.527369 1.30842 0.527369 1.94158 0.917893 2.33211L2.33211 0.917893ZM9.66792 0.917902L5.29291 5.29291L6.70712 6.70713L11.0821 2.33212L9.66792 0.917902ZM5.29291 5.29291L0.917921 9.6679L2.33213 11.0821L6.70712 6.70713L5.29291 5.29291ZM11.0821 9.66789L6.70712 5.29291L5.29291 6.70713L9.66789 11.0821L11.0821 9.66789ZM6.70712 5.29291L2.33211 0.917893L0.917893 2.33211L5.29291 6.70713L6.70712 5.29291Z"
                fill="#008755"
              />
            </svg>
            {closeLabel || "Cancel"}
          </button>
          {children}
        </div>
      </FlyoutStyled>
    </ThemeProvider>
  );
};

Flyout.propTypes = {
  children: PropTypes.node,
  openFlyout: PropTypes.bool.isRequired,
  closeFlyout: PropTypes.func.isRequired,
  closeBtn: PropTypes.object,
  closeLabel: PropTypes.string,
};

export default Flyout;
